<template>
    <div class="no-data-found-wrapper text-center p-primary">        
        
        <i v-if="showEmptyAnimation" class="custom-icon custom-icon-search active search-animation custom-icon-large"></i>
        
        <div v-if="showEmptyAnimation">
            <p class="mt-5 mb-0 text-center datatable-empty-data"><b>{{ message }}</b></p>
        </div>
        <div v-else>
            <p class="mb-0 text-center datatable-empty-data"><b>{{ message }}</b></p>
        </div>
        
        
        

        
    </div>
</template>

<script>
    import AppFunction from "../../helpers/app/AppFunction";

    export default {
        name: "EmptyData",
        props: {
            img: {
                type: String,
                default: AppFunction.getAppUrl('images/icons/icon_empty.svg'),
            },
            message: {
                type: String,
                required: true
            },
            showEmptyAnimation: {
                type: Boolean,
                required: false
            }
        }
    }
</script>
